/** Ставка склада производства на дату — для «Себестоимости» (`purchase.tsx`) и блокировки форм. */
import type { WarehouseRate } from "@/api/purchasePrices";
import { rateOn } from "./format";
import { useRates } from "./queries";

export const NO_RATE_TEXT = "ставка склада на дату не задана";

/** Ставка склада на дату: `loading` / `error` — ставки не загрузились, `none` — на дату ставки нет. */
export type RateOn =
  | { state: "loading" }
  | { state: "error"; error: unknown }
  | { state: "none" }
  | { state: "ok"; rate: WarehouseRate };

export function useRateOn(date: string): RateOn {
  const q = useRates();
  if (q.isError) return { state: "error", error: q.error };
  if (!q.data) return { state: "loading" };
  const rate = date ? rateOn(q.data, date) : null;
  return rate ? { state: "ok", rate } : { state: "none" };
}

/** Отправка формы невозможна: ставки на дату нет / не загрузилась. */
export function rateBlocks(rate: RateOn): string | null {
  if (rate.state === "ok") return null;
  if (rate.state === "none") return NO_RATE_TEXT;
  return rate.state === "loading" ? "ставка склада загружается" : "ставка склада не загрузилась";
}
